export default "__VITE_ASSET__Bng9CvDm__"